import React from "react"
import moment from "moment"

import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom"

import { Icon, BackIcon, BriefcaseIcon, CoinIcon, RefundIcon } from "../icons"
import {
  Button,
  Select,
  DatePicker,
  Icon as AIcon,
  Tag,
  Tooltip,
  Popover,
  Checkbox,
  Dropdown,
  Row,
  Col,
  message,
  Menu,
  Popconfirm,
  Form
} from "antd"
import { connect } from "react-redux"
import styled from "styled-components"

const { MonthPicker, RangePicker } = DatePicker
const { Option } = Select

const rangePickerRanges = {
  Today: [moment(), moment()],
  "This Month": [moment().startOf("month"), moment().endOf("month")],
  "Last Month": [
    moment()
      .subtract(1, "month")
      .startOf("month"),
    moment()
      .subtract(1, "month")
      .endOf("month")
  ],
  "This Year": [moment().startOf("year"), moment().endOf("year")],
  "Last Year": [
    moment()
      .subtract(1, "year")
      .startOf("year"),
    moment()
      .subtract(1, "year")
      .endOf("year")
  ]
}

const accountsFromInstitutionUsers = institutionUsers => {
  const institution_accounts = institutionUsers.map(iu =>
    iu.institution_accounts
      .map(account => ({
        ...account,
        institution_name: iu.institution_name
      }))
      .filter(iu => !iu.excluded)
  )

  const accounts = [].concat(...institution_accounts).map(ia => {
    return {
      name: ia.meta["name"],
      institution_account_token_id: ia.token_id,
      displayName: `${ia.meta["name"]} ${ia.meta["number"]}`,
      institution_name: ia.institution_name
    }
  })
  return accounts
}

const formItemLayout = {
  labelCol: { span: 9 },
  wrapperCol: { span: 15 }
}

var isMobile = document
  ? Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 550
  : false

const Content = styled.div`
  .ant-form-item-label label {
    float: left;
  }
  .ant-select {
    width: 100%;
  }
`

const FilterSelect = ({ children, label, onChange, value }) => (
  <Form.Item {...formItemLayout} label={label}>
    <Select
      allowClear
      getPopupContainer={() => document.getElementById("Actions")}
      onChange={onChange}
      value={value}
    >
      {children}
    </Select>
  </Form.Item>
)

const Filter = ({
  // props:
  filterCount,
  clearFilters,
  updateRange,
  filterValues,
  favoritePlaces,
  selectFilter,
  purposes,
  isPopoverVisible,
  onOpenChange,
  categories,
  // optional:
  institutionUsers,
  selectFilterTransactionType,
  selectFilterInstitutionAccountName,
  selectCategoryFilter,
  selectVehicleFilter,
  selectPlaceFilter,
  vehicles
}) => (
  <Popover
    className="Filterx"
    placement="bottom"
    getPopupContainer={() => document.getElementById("Actions")}
    title={
      <span>
        Filter by:
        {filterCount > 0 && (
          <a className="filter-clear-all" onClick={clearFilters}>
            Clear All
          </a>
        )}
      </span>
    }
    {...isPopoverVisible && { visible: isPopoverVisible }}
    content={
      <Content>
        <Form.Item {...formItemLayout} label="Date">
          <RangePicker
            size="small"
            style={{ width: "100%" }}
            format={"MM/DD/YYYY"}
            onChange={updateRange}
            value={filterValues.range}
            ranges={rangePickerRanges}
            onOpenChange={onOpenChange}
          />
        </Form.Item>

        {selectFilterTransactionType && (
          <FilterSelect
            label="Type"
            onChange={selectFilterTransactionType}
            value={filterValues.transaction_type}
          >
            <Option value="Expense">
              <Row type="flex" align="middle">
                <CoinIcon />
                <Col>Expenses</Col>
              </Row>
            </Option>
            <Option value="Revenue">
              <Row type="flex" align="middle">
                <RefundIcon />
                <Col>Revenue</Col>
              </Row>
            </Option>
          </FilterSelect>
        )}

        <FilterSelect
          label="Purpose"
          onChange={selectFilter}
          value={filterValues.purpose}
        >
          {["Unclassified", ...purposes].map(purpose => (
            <Option key={purpose} value={purpose}>
              {purpose}
            </Option>
          ))}
        </FilterSelect>

        {selectFilterInstitutionAccountName && (
          <FilterSelect
            label="Bank Account"
            onChange={selectFilterInstitutionAccountName}
            value={filterValues.institution_account_token_id}
          >
            {accountsFromInstitutionUsers(institutionUsers).map(account => (
              <Option
                key={account.institution_account_token_id}
                value={account.institution_account_token_id}
                title={account.institution_account_token_id}
              >
                <span style={{ color: "#dcd" }}>
                  {account.institution_name}{" "}
                </span>{" "}
                {account.displayName}
              </Option>
            ))}
          </FilterSelect>
        )}

        {selectCategoryFilter && (
          <FilterSelect
            label="Category"
            onChange={selectCategoryFilter}
            value={filterValues.category}
          >
            {categories.map(category => (
              <Option key={category} value={category}>
                {category}
              </Option>
            ))}
          </FilterSelect>
        )}

        {selectPlaceFilter && (
          <FilterSelect
            label="Favorite Place"
            onChange={selectPlaceFilter}
            value={filterValues.place_token_id}
          >
            {favoritePlaces.visibleIds.map(placeId => (
              <Option key={placeId} value={placeId}>
                {favoritePlaces.byId[placeId].name}
              </Option>
            ))}
          </FilterSelect>
        )}

        {selectVehicleFilter && (
          <FilterSelect
            label="Vehicle"
            onChange={selectVehicleFilter}
            value={filterValues.vehicle_id}
          >
            {vehicles.map(vehicle => (
              <Option key={vehicle.id} value={vehicle.id}>
                {vehicle.nickname} {vehicle.make} {vehicle.model}
              </Option>
            ))}
          </FilterSelect>
        )}
      </Content>
    }
    trigger="click"
  >
    {!isMobile ? (
      <Button type={filterCount > 0 && "primary"} icon="filter">
        Filter{filterCount > 0 && (
          <span className="filter-count">{filterCount}</span>
        )}
      </Button>
    ) : (
      <Button type={filterCount > 0 && "primary"} icon="filter">
        {filterCount > 0 && <span className="filter-count">{filterCount}</span>}
      </Button>
    )}
  </Popover>
)

export default Filter



// WEBPACK FOOTER //
// ./src/core/Filter/index.js